// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2c60f7ea","28":"05b9cf49","75":"c116e3b6","390":"a9294606","896":"0aec669d","916":"c0847d77"}[chunkId] + ".chunk.js";
};